import { render, staticRenderFns } from "./ChatIconNew.vue?vue&type=template&id=4215e90c"
import script from "./ChatIconNew.vue?vue&type=script&lang=ts"
export * from "./ChatIconNew.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4215e90c')) {
      api.createRecord('4215e90c', component.options)
    } else {
      api.reload('4215e90c', component.options)
    }
    module.hot.accept("./ChatIconNew.vue?vue&type=template&id=4215e90c", function () {
      api.rerender('4215e90c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/ChatIconNew.vue"
export default component.exports